module.exports = __webpack_public_path__ + "static/media/24-7.2d60b2b9.mp3";